<template>
  <div>
    <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
    <v-card v-if="!loading&&data" flat>
      <v-card-title class="accent white--text title">
        {{title | translate}}
      </v-card-title>
      <v-card-text v-if="!loading&&data">
        <v-layout row wrap>
          <v-flex xs12 v-for="item in data">
            <vue-plotly :white-mode="whiteMode" v-if="item" :data="item" :layout="layout" :options="{}"/>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {callAPI} from '@/helper'
import LoadingProgressBar from './../LoadingProgressBar'
import VuePlotly from "./../VuePlotly";

export default {
  props: {
    title: {type: String, default: "Chiller Staging"},
    xTitle: {type: String, default: "Cooling Load (kW)"},
    yTitle: {type: String, default: "COP"},
    dateRange: {type: Object, default: null},
      whiteMode:{type:Boolean, default: false},
  },
  components: {LoadingProgressBar, VuePlotly},
  name: 'StagingProfileWidget',
  watch: {
    dateRange() {
      this.refresh()
    },
  },
  computed: {
    layout() {
      return {
        title: "",
        legend: {
          orientation: 'h',
          traceorder: 'normal',
          y: -0.3
        },
        showlegend: true,
        hovermode: "closest",
        hoverlabel: {
          namelength: -1,
        },
        height: 300,
        margin: {
          l: 50,
          r: 50,
          t: 30,
          pad: 1
        },
        xaxis: {title: this.$options.filters.translate(this.xTitle)},
        yaxis: {title: this.$options.filters.translate(this.yTitle)},
      }
    },
  },
  data: function () {
    return {
      loading: true,
      timeout: null,
      data: null
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    debounce(callback, wait) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => callback(), wait);
    },
    refresh() {
      this.debounce(this.getData, 200);
    },
    async getData() {
      let me = this
      this.loading = true
      let chillers = []
      for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
        let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
        if (equip.equipment_type.toLowerCase().startsWith('chiller')) {
          let allSensors = this.$store.state.pointsListStore.pointsList.sensors[i]
          if (allSensors.indexOf("Cooling_Load") > -1 && (allSensors.indexOf("Power") > -1)) {
            chillers.push(equip.equipment_name)
          }
        }
      }
      let param = {
        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
        'equipment_names': chillers,
        'date_range': this.dateRange ? [this.dateRange.start, this.dateRange.end] : null
      }
      let res = await callAPI('stagingprofile/',
          param
      )
      let df = res.data.result
      let output = []
      for (let i in df) {
        let index = i.replace(/[{}]/g, "")
        let mydf = df[i];
        for (let index in mydf.COP) {
          if (mydf.COP[index] > 20) {
            delete (mydf.COP[index])
            delete (mydf.Cooling_Load[index])
          }
        }
        let nbOfItems = i.split(',').length
        if (!output[nbOfItems]) {
          output[nbOfItems] = []
        }
        output[nbOfItems].push({
          'y': mydf.COP, 'x': mydf.Cooling_Load, type: 'scattergl', mode: 'markers', 'name': index
        })
      }
      this.data = output
      this.loading = false

    }
  },
}
</script>

<style scoped>

</style>
